import React from 'react';
import MultiSelectFilter from 'components/ReactTable/Filters/MultiSelectFilter';
import WorkflowStageFilter from 'components/ReactTable/Filters/WorkflowStageFilter';
import SelectFilter from 'components/ReactTable/Filters/SelectFilter';
import GetOptions from 'components/HomePage/GridColumnDefinitions/GetOptions';

// note: for the sorting to work, the 'accessor' properties below must have the same name as the backend property to be sorted by
const advancedSearchColumnDefs = isMultiDb => [
  {
    Header: 'Client',
    accessor: 'clientName',
    disableFilters: true,
    className: 'col-7p5',
    disableSortBy: isMultiDb
  },
  {
    Header: 'Legal Entity',
    accessor: 'legalEntityName',
    className: 'col-17p'
  },
  {
    Header: 'Account Number',
    accessor: 'accountNumber',
    className: 'col-17p'
  },
  {
    Header: 'Account Name',
    accessor: 'accountName',
    className: 'col-17p'
  },
  {
    Header: 'Is Active?',
    accessor: 'accountIsActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-7p5'
  },
  {
    Header: 'Customer Id',
    accessor: 'customerId',
    className: 'col-17p'
  },
  {
    Header: 'Customer Name',
    accessor: 'customerName',
    className: 'col-17p'
  },
  {
    Header: 'Is Active?',
    accessor: 'customerIsActive',
    Filter: SelectFilter,
    filterType: 'bool',
    options: GetOptions('isActive'),
    className: 'col-7p5'
  },
  {
    Header: 'Form Type',
    accessor: 'formTypeDescription',
    Filter: MultiSelectFilter,
    className: 'col-7p5'
  },
  {
    Header: 'Validity',
    accessor: 'validityDescription',
    Filter: MultiSelectFilter,
    className: 'col-7p5'
  },
  {
    Header: 'Form Expiry',
    accessor: 'validUntil',
    disableFilters: true,
    className: 'col-7p5'
  },
  {
    Header: 'Workflow',
    accessor: 'workflowStatus',
    Filter: props => <WorkflowStageFilter { ...props } showStpOnly />,
    className: 'col-10p'
  },
  {
    Header: 'Item Id',
    accessor: 'itemId',
    isVisible: false
  }
];

export default advancedSearchColumnDefs;
